import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from "prop-types";
import Lockable from "components/Lockable";
import Framework from '@beardeddevops/react.framework';

class SidebarContent extends Lockable {

	static propTypes = {
		locations: PropTypes.array,
	};

	render() {
		return (
			<>
				<li>
					<Link data-id={'dashboard'} variant={"text"} to="/dashboard">
						<i className="fa fa-tachometer"/>
						<span className="nav-text">Dashboard</span>
					</Link>
				</li>
				{!this.props.altrupay_users.includes(this.props.account) && <>
					<li>
						<Link data-id={'access-logs'} variant={"text"} to="/access">
							<i className="fa fa-file-text-o"/>
							<span className="nav-text">Access Log</span>
						</Link>
					</li>
					<li>
						<Link data-id={'access-logs'} variant={"text"} to="/tokens">
							<i className="fa fa-file-text-o"/>
							<span className="nav-text">API Tokens</span>
						</Link>
					</li>
				</>}
			</>
		);
	}
}

export default Framework.Components.withRootState(withRouter(SidebarContent));
